import styled from "@emotion/styled";
import * as React from "react";
import { FieldRenderProps } from "react-final-form";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

import { fieldErrorCss } from "./styled";

const StyledNumberInput = styled.span`
  position: relative;
  display: inline-block;

  input {
    line-height: 18px;
    border-radius: 4px;
    border: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
    padding: 10px;
    color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.primaryColor80
    };
    max-width: 100%;
    box-sizing: border-box;
  }

  span.field-error {
    ${fieldErrorCss};
  }
`;

interface IProps extends FieldRenderProps<string, HTMLInputElement> {
  fieldRef?(ref: HTMLInputElement): void;
  className?: string;
}

export const PasswordInput: React.FC<IProps> = ({ className, fieldRef, meta, input }) => (
  <StyledNumberInput className={className}>
    <input type="password" ref={fieldRef} {...input} />
    {meta.submitFailed && <span className="field-error">{meta.error || meta.submitError}</span>}
  </StyledNumberInput>
);
